import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/apps/viewup/app/privacy/_components/PrivacyClientPage/PrivacyClientPage.tsx");
